import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const styles = {
  size: {
    '6xl': 'text-8xl',
    '4xl': 'text-7xl',
    '2xl': 'text-6xl',
    xl: 'text-5xl',
    lg: 'text-4xl',
    md: 'text-3xl',
    sm: 'text-2xl',
  },
  theme: {
    white: 'text-white',
    black: 'text-black',
    purple: 'text-purple',
  },
};

export const Heading2 = ({
  className: additionalClassName,
  tag: Tag,
  size,
  theme,
  asHTML,
  children,
  ...otherProps
}) => {
  const className = clsx(styles.size[size], styles.theme[theme], additionalClassName);

  if (asHTML) {
    return (
      <Tag className={className} dangerouslySetInnerHTML={{ __html: children }} {...otherProps} />
    );
  }

  return (
    <Tag className={className} {...otherProps}>
      {children}
    </Tag>
  );
};

Heading2.propTypes = {
  className: PropTypes.string,
  tag: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.keys(styles.size)).isRequired,
  theme: PropTypes.oneOf(Object.keys(styles.theme)).isRequired,
  asHTML: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Heading2.defaultProps = {
  className: null,
  asHTML: false,
};

export default Heading2;
